import styled from 'react-emotion';
import { FaTimes } from 'react-icons/fa';
import { Button } from 'antd';
import {
  space, color, fontSize, width, borderTop, borderColor,
} from 'styled-system';

import { bouncyBoyMixin, clipTextMixin } from '../../styles';

export const CloseEditorButton = styled(FaTimes)`
  ${space}
  ${fontSize}
  ${color}
  
  position: absolute;
  right: 10px;
  cursor: pointer;
  &:hover {
    color: #333;
  }

  ${bouncyBoyMixin}
`;

export const EditorWrapper = styled('section')`
  position: relative;
  display: ${props => props.open ? 'block' : 'none'};
  width: 20vw;
  height: 100%;
  max-width: 400px;
  min-width: 280px;
  ${space}
  ${color}
  overflow-y: auto;

  label {
    text-transform: capitalize;
  }

  form section {
    margin-bottom: 24px;
  }

  form center section {
    margin-bottom: 2px;
  }
`;

export const EditorHeader = styled('h1')`
  font-weight: bold;
  letter-spacing: 1px;
  ${color}
  ${space}
  ${fontSize}
  ${clipTextMixin}
`;

export const DashboardEditorButton = styled(Button)`
  ${color}
  ${fontSize}
  ${width}
  ${space}
  margin-top: 4px;
`;

export const DashboardFooter = styled('center')`
  ${space}
  ${color}
  ${width}
  ${borderTop}
  ${borderColor}
  padding: 9px 0;
  text-align: center;
  position: absolute;
  left: 0;
`;

export const DeleteDashboard = styled('h4')`
  ${space}
  ${color}
  text-align: center;
  font-weight: 300;
  cursor: pointer;
  user-select: none;
  letter-spacing: 1px;
  ${bouncyBoyMixin}
  font-size: 16px;
`;
